import { useCallback } from 'react'
import { writePaymentMetafield, writeBnplxAttributes, type PaymentMetafield } from '../lib/graphql'

export function useMetafield(draftOrderGid: string) {
    const write = useCallback(async (payment: PaymentMetafield) => {
        try {
            await writePaymentMetafield(draftOrderGid, payment)
        } catch (err) {
            console.warn('Failed to write metafield:', err)
            // Non-fatal — metafield is cache, BNPLX is source of truth
        }
        // Mirror the status (and the current payment id, when present) to the
        // externally-readable custom attributes so systems syncing the order
        // (e.g. BC) can gate shipping on it. Mirroring the payment id here keeps
        // bnplx_payment_id in sync when a retry/reconcile swaps in a new payment
        // (otherwise it stays pinned to the first, possibly-declined, payment).
        // Best-effort: never block the guarantee flow on it.
        try {
            await writeBnplxAttributes(draftOrderGid, {
                ...(payment.paymentId ? { paymentId: payment.paymentId } : {}),
                status: payment.status,
            })
        } catch (err) {
            console.warn('Failed to mirror bnplx attributes:', err)
        }
    }, [draftOrderGid])

    const clear = useCallback(async () => {
        try {
            await writePaymentMetafield(draftOrderGid, {
                paymentId: '',
                status: '',
                amount: '',
                currency: '',
            })
        } catch (err) {
            console.warn('Failed to clear metafield:', err)
        }
        try {
            await writeBnplxAttributes(draftOrderGid, { status: null })
        } catch (err) {
            console.warn('Failed to clear bnplx_status attribute:', err)
        }
    }, [draftOrderGid])

    return { write, clear }
}
